const WindowEvents = (message) => {
    if (message === 'PICO/READY') {
        const picoInitializing = new Event('pico.ready')
        window.dispatchEvent(picoInitializing)
    }

    if (message === 'PICO/INIT') {
        const picoInitializing = new Event('pico.init')
        window.dispatchEvent(picoInitializing)
    }

    if (message === 'PICO/LOADED') {
        const picoInitializing = new Event('pico.loaded')
        window.dispatchEvent(picoInitializing)
    }

    if (message === 'PICO/UPDATED') {
        const picoInitializing = new Event('pico.updated')
        window.dispatchEvent(picoInitializing)
    }
}

export default WindowEvents
